module.exports = __webpack_public_path__ + "static/media/save-headaches.0581928e.svg";